import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { useFetchFBAdAccountIdsQuery } from '../hooks';
import { FacebookAdAccount } from '../types';

type FacebookAdAccountsState = {
  fbAdAccounts: FacebookAdAccount[];
};

const defaultFacebookAdAccountsState = {
  fbAdAccounts: [],
};

export const FacebookAdAccountsContext = createContext<FacebookAdAccountsState>(
  defaultFacebookAdAccountsState,
);

export const useFacebookAdAccounts = () => useContext(FacebookAdAccountsContext);

export const FacebookAdAccountsProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { fbAdAccounts = [] } = useFetchFBAdAccountIdsQuery();
  return (
    <FacebookAdAccountsContext.Provider value={{ fbAdAccounts }}>
      {children}
    </FacebookAdAccountsContext.Provider>
  );
};
